"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLightMeetingsBuildVersion = exports.getBaseLightMeetingsUrl = exports.buildLightMeetingsUrl = void 0;
const UrlHelper_1 = require("./UrlHelper");
const GA_CLOUD_ORIGIN = "https://teams.microsoft.com"; /* GA endpoint */
const LIGHT_MEETINGS_URL_PATH = "/light-meetings/launch";
const buildLightMeetingsUrl = ({ joinInfo, container, buildVersion, deeplinkId, correlationId, queryParams, token, }) => {
    const url = (0, exports.getBaseLightMeetingsUrl)();
    if (queryParams) {
        const { clientVersion } = queryParams, filteredQueryParams = __rest(queryParams, ["clientVersion"]);
        UrlHelper_1.UrlHelper.setQueryParameters(url, filteredQueryParams);
    }
    url.searchParams.set("agent", "web");
    container && url.searchParams.set("container", container);
    buildVersion && url.searchParams.set("version", buildVersion);
    url.searchParams.set("coords", btoa(JSON.stringify(joinInfo)));
    deeplinkId && url.searchParams.set("deeplinkId", deeplinkId);
    correlationId && url.searchParams.set("correlationId", correlationId);
    if (token) {
        // encodeURIComponent is defense-in-depth: a no-op for base64url chars (A-Z, a-z, 0-9, _, -, .)
        // that make up a valid JWT, but ensures any unexpected characters are safely escaped.
        url.hash = `token=${encodeURIComponent(token)}`;
    }
    return url.toString();
};
exports.buildLightMeetingsUrl = buildLightMeetingsUrl;
/**
 * Returns the base URL for the light-meetings experience.
 * note: exported only for testing.
 */
const getBaseLightMeetingsUrl = () => {
    const currentOrigin = UrlHelper_1.UrlHelper.getOrigin();
    // Use the GA hostname for dev host (local environment).
    const urlOrigin = new URL(currentOrigin).hostname === "localhost" ? GA_CLOUD_ORIGIN : currentOrigin;
    return new URL(LIGHT_MEETINGS_URL_PATH, urlOrigin);
};
exports.getBaseLightMeetingsUrl = getBaseLightMeetingsUrl;
const getLightMeetingsBuildVersion = ({ isLightMeetingsDgjEnvironment, clientVersion, skipLimeBuildVersionInQsp, lightMeetingsBuildVersion, lightMeetingsWebBuildVersion, }) => {
    // For DGJ, continue to set the build version explicitly
    // until we switch to the LIME YAML pipeline for all platforms
    if (isLightMeetingsDgjEnvironment) {
        return lightMeetingsBuildVersion;
    }
    if (clientVersion) {
        return clientVersion;
    }
    if (skipLimeBuildVersionInQsp) {
        return undefined;
    }
    return lightMeetingsWebBuildVersion;
};
exports.getLightMeetingsBuildVersion = getLightMeetingsBuildVersion;
